import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { howItWorksHeroImage } from '@/mocks/howItWorks';

export default function Hero() {
  const { t } = useTranslation('howItWorks');
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <section className="relative w-full overflow-hidden flex items-center min-h-[315px] md:min-h-[360px] lg:min-h-[420px]">
      <img
        src={howItWorksHeroImage}
        alt={t('hero.imageAlt')}
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50" />

      <div className="relative w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
        <div className="max-w-4xl mx-auto text-center">
          <h1
            className={`text-4xl sm:text-5xl md:text-6xl font-bold text-white leading-[1.08] mb-4 md:mb-5 transition-all duration-700 delay-100 ${
              mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            {t('hero.title')}
          </h1>

          <p
            className={`text-lg md:text-xl font-medium text-warm-200 mb-4 md:mb-6 transition-all duration-700 delay-200 ${
              mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            {t('hero.subtitle')}
          </p>
        </div>
      </div>
    </section>
  );
}